<template>
  <div class="not-found">
    <div class="container">
      <div class="not-found-icon">404</div>
      <h2>頁面未找到</h2>
      <p>很抱歉，您請求的頁面不存在或已被移除。</p>
      <div class="actions">
        <el-button type="primary" @click="$router.push('/')">返回首頁</el-button>
        <el-button @click="goBack">返回上一頁</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView',
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.not-found {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 20px;
}

.container {
  text-align: center;
  max-width: 600px;
}

.not-found-icon {
  font-size: 6rem;
  color: #409eff;
  margin: 0;
}

h2 {
  font-size: 2rem;
  color: #333;
  margin: 10px 0 20px;
}

p {
  color: #666;
  font-size: 1.2rem;
  margin-bottom: 30px;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 15px;
}
</style> 